import { getDefaultPath } from '../../helpers/urlSync';
import actions from './actions';
import { createReducer } from '../../helpers/reducer';
import { getView } from '../../helpers/view';
import breadcrumbState from '../../settings/breadcrumbs/breadcrumbMap';
import { getOrganizationTheme } from '../../settings/themeSettings';

const preKeys = getDefaultPath();

const initState = {
  loading: false,
  theme: getOrganizationTheme(null),
  collapsed: !(window.innerWidth > 1220),
  view: getView(window.innerWidth),
  height: window.innerHeight,
  openKeys: preKeys,
  current: preKeys,
  notificationsUnreadCount: [],
  notifications: [],
  breadcrumbState: breadcrumbState(),
  settingsSidebarVisible: false,
};

function onCollapseChange(state) {
  return {
    ...state,
    collapsed: !state.collapsed,
  };
}

function onToggleAll(state, action) {
  const height = action.height ? action.height : state.height;

  return {
    ...state,
    collapsed: state.view !== action.view ? action.collapsed : state.collapsed,
    view: action.view,
    width: action.width,
    height,
  };
}

function onChangeOpenKeys(state, action) {
  return {
    ...state,
    openKeys: action.openKeys,
  };
}

function onChangeCurrent(state, action) {
  return {
    ...state,
    current: action.current,
  };
}

function onCloseAll(state) {
  return {
    ...state,
    openKeys: [],
    current: [],
  };
}

function getUnreadNotificationsCountSuccess(state, action) {
  return {
    ...state,
    notificationsUnreadCount: action.notificationsUnreadCount,
  };
}

function notificationMarkAsRead(state) {
  const notifications = [...state.notifications];

  return {
    ...state,
    notifications,
  };
}

function setInitBreadcrumbState(state) {
  return {
    ...state,
    breadcrumbState: breadcrumbState(),
  };
}

function onChangeBreadcrumbState(state, payload) {
  return {
    ...state,
    breadcrumbState: {
      ...state.breadcrumbState,
      [payload.data.prop]: payload.data.value,
    },
  };
}

function onLoadThemeRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadThemeSuccess(state, { payload }) {
  const { branding_settings } = payload;

  return {
    ...state,
    theme: getOrganizationTheme(branding_settings),
    loading: false,
  };
}

function onLoadThemeError(state) {
  return {
    ...state,
    loading: false,
  };
}

function onSetSettingsSidebarVisible(state, action) {
  return {
    ...state,
    settingsSidebarVisible: action.visible,
  };
}

export default createReducer(initState, {
  [actions.COLLAPSE_CHANGE]: onCollapseChange,
  [actions.TOGGLE_ALL]: onToggleAll,
  [actions.CHANGE_OPEN_KEYS]: onChangeOpenKeys,
  [actions.CHANGE_CURRENT]: onChangeCurrent,
  [actions.CLOSE_ALL]: onCloseAll,
  [actions.GET_UNREAD_NOTIFICATIONS_COUNT_SUCCESS]: getUnreadNotificationsCountSuccess,
  [actions.NOTIFICATION_MARK_AS_READ]: notificationMarkAsRead,
  [actions.SET_INIT_BREADCRUMB_STATE]: setInitBreadcrumbState,
  [actions.CHANGE_BREADCRUMB_STATE]: onChangeBreadcrumbState,
  [actions.LOAD_THEME_REQUEST]: onLoadThemeRequest,
  [actions.LOAD_THEME_SUCCESS]: onLoadThemeSuccess,
  [actions.LOAD_THEME_ERROR]: onLoadThemeError,
  [actions.SET_SETTINGS_SIDEBAR_VISIBLE]: onSetSettingsSidebarVisible,
});
